import { render, staticRenderFns } from "./ShopRegister.vue?vue&type=template&id=b0ff575a&scoped=true&"
import script from "./ShopRegister.vue?vue&type=script&lang=js&"
export * from "./ShopRegister.vue?vue&type=script&lang=js&"
import style0 from "./ShopRegister.vue?vue&type=style&index=0&id=b0ff575a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0ff575a",
  null
  
)

export default component.exports